<template>
    <div class="login-container">
        <div class="login-white-bar">
            <div>
                <div>
                    <h2 class="login-head">QESTIT</h2>
                </div>
                <div>
                    <p class="login-p">Sign in using your Office 365 account.</p>
                </div>
                <div>
                    <vs-button type="filled" @click="login" class="header-button login">Authenticate with Office 365
                    </vs-button>
                </div>
                <p v-if="loader" class="loader-p">Loading...</p>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Login",
        data: () => {
            return {
                loader: false
            }
        },
        methods: {
            /**
             * Trigger login request
             */
            login: function () {
                this.loader = true;
                this.$store.dispatch("login")
                    .then(
                        response => {
                            // if the response having access token
                            if (response.access_token) {
                                // set auth values
                                this.$store.commit("setAuth", true);
                                this.$store.commit("setToken", response.access_token);
                                // this.$store.commit("setUserPrincipalName", response.userPrincipalName);
                                // // redirect to home page
                                // this.$router.push({name: 'home'});
                                this.fetchUserAndRedirect();
                            }
                            this.loader = false;
                        },
                        error => {

                            this.loader = false;
                        }
                    );
            },
            fetchUserAndRedirect: function () {
                this.$store.dispatch("fetchPodioUser")
                    .then(
                        response => {
                            if (this.$route.query && this.$route.query.redirect) {
                                this.$router.push({path: this.$route.query.redirect});
                            } else if (response.canAccessQForecastForecasting) {
                                this.$router.push({name: 'forecast', query: {redirect: 'true'}});
                            } else if (!response.canAccessQForecastForecasting && response.canAccessQForecastReporting) {
                                this.$router.push({name: 'reports', query: {redirect: 'true'}});
                            } else {
                                this.$router.push({name: 'qtime', query: {redirect: 'true'}});
                            }
                        }
                    );
            }
        }
    }
</script>

<style>
    .login-container {
        width: 100%;
        height: 100vh;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
        justify-content: center;
        -webkit-justify-content: center;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        background: url("../../../public/assets/images/bg/bg.png") no-repeat;
        background-size: cover;
    }

    .login-white-bar {
        display: flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
        justify-content: center;
        -webkit-justify-content: center;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        width: 791px;
        height: 265px;
        text-align: center;
        box-shadow: 1px -4px 108px 0px rgba(0, 0, 0, 0.06);
        -webkit-box-shadow: 1px -4px 108px 0px rgba(0, 0, 0, 0.06);
        -moz-box-shadow: 1px -4px 108px 0px rgba(0, 0, 0, 0.15);
        background: #ffffff;
        transform: translateY(100px);
        -webkit-transform: translateY(100px);
        -moz-transform: translateY(100px);
        animation: up 0.6s forwards ease;
        -webkit-animation: up 0.6s forwards ease;
        -moz-animation: up 0.6s forwards ease;
    }

    @keyframes up {
        80% {
            transform: translateY(-20px);
            -webkit-transform: translateY(-20px);
            -moz-transform: translateY(-20px);
        }

        100% {
            transform: translateY(0);
            -webkit-transform: translateY(0);
            -moz-transform: translateY(0);
        }
    }

    .login-white-bar > div {
        display: block;
        width: 100%;
    }

    .login-head {
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 31px;
        margin-bottom: 28px;
    }

    .login-white-bar > div {
        display: block;
        width: 100%;
    }

    .login-head {
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 31px;
        margin-bottom: 28px;
    }

    .login-p {
        margin-bottom: 26px;
    }

    .loader-p {
        margin-top: 10px;
    }
</style>
